var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGasStorageUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E124A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288-288h384q70 0 119-49t49-119q0-70-49-119t-119-49H288q-70 0-119 49t-49 119q0 70 49 119t119 49Zm192-168Zm-72-240h144v-48H408v48ZM288-120v-96q-100 0-170-70T48-456q0-100 70-170t170-70h48v-48q0-29.7 21.18-50.85Q378.35-816 408.09-816h144.17Q582-816 603-794.85q21 21.15 21 50.85v48h48q100 0 170 70t70 170q0 100-70 170t-170 70v96h-72v-96H360v96h-72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGasStorageUnitIcon);
export default __webpack_public_path__ + "static/media/marker-gasStorageUnit-icon.00e8da7261349a4105fb03c4b0a05ca2.svg";
export { ForwardRef as ReactComponent };